// eslint-disable-next-line import/no-duplicates
import { parseISO, format } from 'date-fns';
// eslint-disable-next-line import/no-duplicates
import { de } from 'date-fns/locale';

export const parsedDate = (date: Date | string): Date | number =>
    typeof date === 'string' ? parseISO(date) : Date.parse(String(date));

export const formatDate = (date: Date | string | number, formatDate?: string) => {
    const getFormat = (date: Date | number) => format(date, formatDate || 'dd.MM.yyyy', { locale: de });

    return typeof date === 'number' ? getFormat(date) : parsedDate(date) ? getFormat(parsedDate(date)) : '';
};
